// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".how-to-improve .insights-content{font:400 15px/23px \"Poppins\";color:#1E2B4E}.how-to-improve .insights-content ul{list-style:none;padding-left:0;margin-top:24px}.how-to-improve .insights-content ul li{padding:16px 0;border-bottom:1px solid #f5f5f5}.how-to-improve .insights-content ul li:last-child{border-bottom:none}.how-to-improve .iterations-content{font:400 15px/23px \"Poppins\";color:#1E2B4E}.how-to-improve .mt-3{margin-top:32px}\n", ""]);
// Exports
module.exports = exports;
